import React from 'react'
import { formatDateTime } from '../../utils/api'
import { timeLeft, deadlineDate, URGENCY_BADGE, URGENCY_BORDER, STEP_WORD } from './ebayRequestFormat.js'

const KIND_WORD = { return: 'return', not_received: 'request' }

// What staff must do on eBay for this case, in order, and by when. The step
// states come from eBay's own record, so this cannot say Done when eBay disagrees.
// Spec: docs/specs_20261013_ebay_return_flow.md
function EbayRequestNotice({ request }) {
  if (request.closed_at) {
    return (
      <p className="text-muted" style={{ marginBottom: 'var(--space-4)' }}>
        The eBay {KIND_WORD[request.kind]} closed on {formatDateTime(request.closed_at)} ({request.status}).
      </p>
    )
  }

  const hasDeadline = request.urgency !== 'none' && request.respond_by

  return (
    <div
      className="card"
      role="alert"
      style={{ marginBottom: 'var(--space-4)', borderColor: URGENCY_BORDER[request.urgency], borderWidth: 2, borderStyle: 'solid' }}
    >
      <strong>{request.headline}</strong>
      <p>eBay only counts what you do on eBay. Work in Prism does not count.</p>
      {hasDeadline && (
        <p>
          Next deadline: <strong>{deadlineDate(request.respond_by)}</strong>{' '}
          <span className={`badge ${URGENCY_BADGE[request.urgency]}`}>{timeLeft(request.respond_by)}</span>
        </p>
      )}
      <ol style={{ listStyle: 'none', padding: 0, margin: 'var(--space-3) 0' }}>
        {request.steps.map((step, index) => (
          <li key={step.label} style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center', marginBottom: 'var(--space-1)' }}>
            <span className={`badge ${step.state === 'now' ? 'badge-error' : 'badge-neutral'}`}>{STEP_WORD[step.state]}</span>
            <span>{request.steps.length > 1 ? `${index + 1}. ` : ''}{step.label}</span>
          </li>
        ))}
      </ol>
      {request.note && <p>{request.note}</p>}
      <a className="btn btn-sm btn-primary" href={request.url} target="_blank" rel="noreferrer">
        Open this {KIND_WORD[request.kind]} on eBay
      </a>
    </div>
  )
}

export default EbayRequestNotice
